import { useEffect, useMemo, useState } from 'react';
import { formApi } from '../../../services';
import { FormResponse } from '../useFormResponses';
import { SlotField, toBookingEvents } from './bookingEvents';

export const useBookingEvents = (tenantId?: string, formId?: string, slotFields: SlotField[] = []) => {
  const [responses, setResponses] = useState<FormResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!tenantId || !formId) return;
    let cancelled = false;

    const fetchAll = async () => {
      setLoading(true);
      setError('');
      try {
        const result = await formApi.getFormResponses(tenantId, formId);
        if (!cancelled) setResponses(Array.isArray(result) ? result : result?.rows || []);
      } catch (err: any) {
        if (!cancelled) setError(err?.message || 'Unable to load bookings');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchAll();
    return () => {
      cancelled = true;
    };
  }, [tenantId, formId]);

  const events = useMemo(() => toBookingEvents(responses, slotFields), [responses, slotFields]);

  return { events, loading, error };
};
